import Vue from "vue";
import packageJson from '@/../package.json';

// Components
import "./components";

// Plugins
import "./plugins";
import "./plugins/axios";
import "./plugins/toasted";
import "./plugins/echarts";
import "./utils";
import '@/assets/js/filters'
import { sync } from "vuex-router-sync";

// Application imports
import App from "./App";
import router from "@/router";
import store from "@/store";
import VueMce from 'vue-mce';
import tinymce from 'vue-tinymce-editor'
import enviroment from "@/enviroment";

import VMdDateRangePicker from "v-md-date-range-picker";
import "v-md-date-range-picker/node_modules/moment/locale/pt-br";
import "moment/locale/pt-br";

import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";

Vue.use(VueMce);
Vue.use(VMdDateRangePicker);
Vue.component('tinymce', tinymce)

// Sync store with router
sync(store, router);

Vue.config.productionTip = false;
Vue.prototype.window = window;
Vue.prototype.$eventHub = new Vue();

Sentry.init({
  dsn: enviroment.sentryDns,
  integrations: [
    new VueIntegration({
      Vue,
      attachProps: true,
      logErrors: true,
    }),
  ],
  release: packageJson.name + '@' + packageJson.version,
  sendDefaultPii: true,
});

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
